// test2936
(2936 && 0);
